module.exports = __webpack_public_path__ + "img/LIVE.d1654e46.jpeg";